import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLazyLoad from 'vue-lazyload'
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
	config: { id: "AW-617595693" }
});

Vue.use(VueLazyLoad)

Vue.config.productionTip = false

import Utils from '@/classes/Utils'
const utils = new Utils(process.env.VUE_APP_IS_DEBUG)
Vue.prototype.$utils = utils

import Api from '@/classes/Api'
const api = new Api()
Vue.prototype.$api = api

import Consts from '@/classes/Consts'
const consts = new Consts()
Vue.prototype.$consts = consts

import Info from '@/classes/Info'
const info = new Info()
Vue.prototype.$info = info

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
